'use client';

import React from 'react';
import { EmailLogsPanel } from '@contentgrowth/content-emailing/frontend';
import { useEmailService } from '@/app/admin-tools/api/email';

export default function EmailLogsPage() {
    const emailService = useEmailService();

    const fetchLogs = async (params: {
        page: number;
        limit: number;
        status?: string;
        email?: string;
        template?: string;
    }) => {
        // Adapt parameters to API
        // API client currently takes (limit, offset)
        // We need to pass filters too if API supports it.
        // My API client getLogs is: getLogs(limit, offset)
        // Backend logs route might support filters?
        // Let's stick to basic pagination if filters aren't in client yet, 
        // OR update client.
        // The logs panel passes page (1-based), limit.
        const offset = (params.page - 1) * params.limit;

        // Note: The UI props `status`, `email`, `template` are passed but our current default client function
        // `getLogs` only takes limit/offset.
        // Ideally we update the client to accept filters.

        const result = await emailService.getLogs(params.limit, offset);

        // Map backend Log objects if necessary, but interfaces likely match
        return {
            logs: result.logs as any[],
            total: result.total
        };
    };

    return (
        <div className="py-6">
            <EmailLogsPanel
                fetchLogs={fetchLogs}
                title="Delivery Logs"
                pageSize={20}
            />
        </div>
    );
}
